import { render } from "./Checkmark.vue?vue&type=template&id=986412f0&ts=true"
import script from "./Checkmark.vue?vue&type=script&lang=ts"
export * from "./Checkmark.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__